import { useEffect } from 'react';
import { connect } from 'react-redux';
// Redux
import {getCities}  from '../../redux/actions/Cities';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/cities';

const Index = ({stateView, token, getCities}) => {
    const GetData = async() =>{
        const res = await getData(token)
        getCities(res.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Ciudades' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getCities})(Index);
